export abstract class LanguageRepository {
  abstract getBrowserLanguage(): string;
  abstract getLanguageCode(): string;
}
